var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mv_one"},[_c('img',{attrs:{"src":_vm.pic_url,"alt":""},on:{"click":_vm.toMv}}),_c('div',{staticClass:"tt"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }